// extracted by mini-css-extract-plugin
export default {"title":"nlPLa","pages":"S1HjN","button":"dTHZJ"};